import { useRouter } from 'next/router';

// not replace delayNavigate by this hook yet, only delete this comment when all are replaced
export const useDelayNavigate = () => {
  const router = useRouter();
  const delayNavigate = (url: string) => {
    setTimeout(() => {
      router.push(url);
    }, 1500);
  };
  return { delayNavigate };
};

export const delayNavigate = (url: string) => {
  const router = useRouter();
  setTimeout(() => {
    router.push(url);
  }, 1500);
};

export const delayCallback = (callback: Function, timeout: number) => {
  setTimeout(() => {
    callback();
  }, timeout);
};
